import {useAuth} from '@apps-common/auth-react';
import {ENVIRONMENTS} from '@apps-common/ui-components';
import NavBar from '@apps-common/ui-components/NavBar/NavBar.jsx';
import React from 'react';
import {useSelector} from 'react-redux';
import OrgSwitcher from '../OrgSwitcher.jsx';
import APITargetChip from './APITargetChip.jsx';
import HelpMenu from './HelpMenu.jsx';
import ThemeMenu from './ThemeMenu.jsx';
import {reset as resetAnalytics, trackEvent} from '@app/analytics';

const TopNavBar = () => {
  const themeModeLabOn = useSelector(state => state.labs.themeMode);
  const auth = useAuth();

  const logout = () => {
    trackEvent('Logout Button clicked');

    resetAnalytics();

    auth.signOut();
  };

  return (
    <NavBar
      title="Features Manager"
      user={auth.user?.claims}
      secondary={
        <>
          {auth.user && <OrgSwitcher />}

          <APITargetChip />

          {themeModeLabOn && <ThemeMenu />}

          <HelpMenu />
        </>
      }
      logout={logout}
      sx={{zIndex: 'modal'}}
      className="pl-mode-dark"
      environment={ENVIRONMENTS.production}
    />
  );
};

export default TopNavBar;
